"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _WalletButtonsWithdraw = _interopRequireDefault(require("./WalletButtonsWithdraw"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledRow = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  overflow: hidden;\n  max-height: ", ";\n"])), function (props) {
  return props.isActive ? "auto" : "56px";
});

var StyledIcon = (0, _styledComponents.default)(_fiverReactUiComponents.MatIcon)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (props) {
  return props.theme.colorLabel;
});

var StyledText = _styledComponents.default.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  margin-left: 1rem;\n  font-size: 0.875rem;\n"])));

var sharedStyles = (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  font-family: ", ";\n  color: ", ";\n  width: 100%;\n  height: 56px;\n  padding: 0 1rem;\n"])), function (p) {
  return p.theme.fontFamilyDefault;
}, function (p) {
  return p.theme.colorText;
});

var StyledButton = _styledComponents.default.button(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", ";\n"])), sharedStyles);

var StyledAnchor = _styledComponents.default.a(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", ";\n"])), sharedStyles);

var StyledDisabledButton = _styledComponents.default.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  cursor: not-allowed;\n"])), sharedStyles, function (p) {
  return p.theme.colorDisabledText;
});

var StyledDisabledMessage = _styledComponents.default.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  padding: 0 2rem;\n  font-size: 0.875rem;\n  color: ", ";\n  margin-bottom: 1rem;\n  line-height: 1.5;\n\n  & a {\n    color: inherit;\n    font-size: inherit;\n    text-decoration: underline;\n  }\n"])), function (p) {
  return p.theme.colorLabel;
});

var StyledContent = _styledComponents.default.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  padding: 0 2rem 1rem;\n  border-bottom: 2px solid ", ";\n"])), function (props) {
  return props.theme.colorBorder;
});

var StyledEmptyTransactions = _styledComponents.default.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  font-size: 0.875rem;\n  color: ", ";\n"])), function (p) {
  return p.theme.colorLabel;
});

var WalletButtons = function WalletButtons(_ref) {
  var walletLoading = _ref.walletLoading,
      addCardUrl = _ref.addCardUrl,
      addCardError = _ref.addCardError,
      dateLocale = _ref.dateLocale,
      translations = _ref.translations,
      onError = _ref.onError,
      getWallet = _ref.getWallet,
      currencySymbol = _ref.currencySymbol,
      balance = _ref.balance,
      isLoading = _ref.isLoading,
      errorMessage = _ref.errorMessage,
      withdraw = _ref.withdraw,
      activeButton = _ref.activeButton,
      toggleActive = _ref.toggleActive,
      cardAdded = _ref.cardAdded;

  var _useState = (0, _react.useState)({
    withdrawAmount: "",
    withdrawAmountPassword: ""
  }),
      _useState2 = _slicedToArray(_useState, 2),
      form = _useState2[0],
      setForm = _useState2[1];

  var withdrawAmount = form.withdrawAmount,
      withdrawAmountPassword = form.withdrawAmountPassword;

  var handleTextboxChanged = function handleTextboxChanged(e) {
    var _e$target = e.target,
        value = _e$target.value,
        name = _e$target.name;
    setForm(_objectSpread(_objectSpread({}, form), {}, _defineProperty({}, name, value)));
  };

  var isIframe = undefined;

  if (window.self !== window.top) {
    isIframe = true;
  } else {
    isIframe = false;
  }

  return /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.Card, {
    padding: "1rem 0"
  }, /*#__PURE__*/_react.default.createElement(StyledRow, {
    isActive: true
  }, addCardUrl && /*#__PURE__*/_react.default.createElement(StyledAnchor, {
    href: addCardUrl,
    target: "_blank"
  }, /*#__PURE__*/_react.default.createElement(StyledIcon, null, "credit_card"), /*#__PURE__*/_react.default.createElement(StyledText, null, translations.addCard)), !addCardUrl && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(StyledDisabledButton, null, /*#__PURE__*/_react.default.createElement(StyledIcon, null, "credit_card"), /*#__PURE__*/_react.default.createElement(StyledText, null, translations.addCard)), !walletLoading && addCardError && /*#__PURE__*/_react.default.createElement(StyledDisabledMessage, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.Alert, {
    isDanger: true,
    textAlign: "left"
  }, addCardError)))), /*#__PURE__*/_react.default.createElement(StyledRow, {
    isActive: activeButton === 3 || !cardAdded,
    onClick: function onClick() {
      return toggleActive(3);
    }
  }, !cardAdded && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(StyledDisabledButton, null, /*#__PURE__*/_react.default.createElement(StyledIcon, null, "keyboard_return"), /*#__PURE__*/_react.default.createElement(StyledText, null, translations.withdraw)), !walletLoading && /*#__PURE__*/_react.default.createElement(StyledDisabledMessage, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.Alert, {
    isDanger: true,
    textAlign: "left"
  }, translations.addCardToWithdraw))), cardAdded && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(StyledButton, null, /*#__PURE__*/_react.default.createElement(StyledIcon, null, "keyboard_return"), /*#__PURE__*/_react.default.createElement(StyledText, null, translations.withdraw)), /*#__PURE__*/_react.default.createElement(StyledContent, {
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, /*#__PURE__*/_react.default.createElement(_WalletButtonsWithdraw.default, {
    currencySymbol: currencySymbol,
    translations: translations,
    onError: onError,
    getWallet: getWallet,
    balance: balance
  })))));
};

var _default = WalletButtons;
exports.default = _default;